export type AccountingThemeMode = "light" | "dark";
export type AccountingAccent = "indigo" | "ocean" | "forest" | "rose";

export type AccountingPalette = {
  primary: string;
  info: string;
  success: string;
  warning: string;
  error: string;
  appBackground: string;
  headerBackground: string;
  headerText: string;
  siderBackground: string;
  siderText: string;
};

const accountingThemes: Record<AccountingAccent, Record<AccountingThemeMode, AccountingPalette>> = {
  indigo: {
    light: { primary: "#4f46e5", info: "#0ea5e9", success: "#16a34a", warning: "#d97706", error: "#dc2626", appBackground: "#f4f7fb", headerBackground: "#ffffff", headerText: "#172033", siderBackground: "#192c4e", siderText: "#eff4ff" },
    dark: { primary: "#8da2ff", info: "#67d8f9", success: "#48d08e", warning: "#f0b754", error: "#ff8585", appBackground: "#111a28", headerBackground: "#162438", headerText: "#eef3ff", siderBackground: "#0a111b", siderText: "#eef3ff" }
  },
  ocean: {
    light: { primary: "#0284c7", info: "#0891b2", success: "#059669", warning: "#ca8a04", error: "#e11d48", appBackground: "#f2fbfd", headerBackground: "#ffffff", headerText: "#12303c", siderBackground: "#113947", siderText: "#f1fcff" },
    dark: { primary: "#52b8c8", info: "#52b8c8", success: "#40bd95", warning: "#e3b14f", error: "#ff7b72", appBackground: "#0f1f25", headerBackground: "#163039", headerText: "#ecfbff", siderBackground: "#0a181e", siderText: "#ecfbff" }
  },
  forest: {
    light: { primary: "#15803d", info: "#2563eb", success: "#16a34a", warning: "#b45309", error: "#b91c1c", appBackground: "#f2fbf8", headerBackground: "#ffffff", headerText: "#10261f", siderBackground: "#0f3d33", siderText: "#edfdf8" },
    dark: { primary: "#3dc8a4", info: "#7ea6ff", success: "#3dc8a4", warning: "#d7a444", error: "#ff7e75", appBackground: "#0f231f", headerBackground: "#15312b", headerText: "#ebfcf7", siderBackground: "#0a1916", siderText: "#ebfcf7" }
  },
  rose: {
    light: { primary: "#be123c", info: "#2563eb", success: "#15803d", warning: "#d97706", error: "#dc2626", appBackground: "#fff5f7", headerBackground: "#ffffff", headerText: "#3a1620", siderBackground: "#4b1827", siderText: "#fff1f5" },
    dark: { primary: "#fb7185", info: "#8fb4ff", success: "#45be97", warning: "#e5b457", error: "#ff7a72", appBackground: "#251018", headerBackground: "#351723", headerText: "#fff1f5", siderBackground: "#1b0a10", siderText: "#fff1f5" }
  }
};

export function getAccountingPalette(accent: AccountingAccent, mode: AccountingThemeMode) {
  return accountingThemes[accent]?.[mode] ?? accountingThemes.indigo[mode];
}
